'use strict'

import { RECEIVE_DOCUMENTS_FILES, RECEIVE_DOCUMENTS_PICTURES } from '../constants/FileConstants'
import DtoFile from '../dto/DtoFile'
import DtoPicture from '../dto/DtoPicture'


export const store = {
    pictures: [],
    files: [],
}

export function FileReducer(state = {}, action) {
    switch (action.type) {
        case RECEIVE_DOCUMENTS_PICTURES:
            return {
                ...state,
                pictures: action.pictures.map(el => new DtoPicture(el)),
            }
        case RECEIVE_DOCUMENTS_FILES:
            return {
                ...state,
                files: action.files.map(el => new DtoFile(el)),
            }
        default:
            return state
    }
}
